// Bộ hiệu ứng màu cho ảnh.
//
// css      - chuỗi CSS filter, dùng cho cả preview webcam lẫn ctx.filter trên canvas
// grain    - độ mạnh hạt film (0 = tắt)
// vignette - độ tối bốn góc (0 = tắt)
// bloom    - độ toả sáng mềm (0 = tắt)
// wash     - lớp màu phẳng phủ lên trên, dùng để làm bạc màu

export const FILTERS = [
    {
        id: "none",
        label: "Gốc",
        css: "none"
    },
    {
        id: "warm-film",
        label: "Film ấm",
        css: "sepia(0.25) saturate(1.15) contrast(1.05) brightness(1.05)",
        grain: 0.06,
        vignette: 0.15
    },
    {
        id: "y2k",
        label: "Y2K Fade",
        css: "contrast(0.85) saturate(1.35) brightness(1.1)",
        grain: 0.04,
        wash: "rgba(255, 255, 255, 0.07)"
    },
    {
        id: "pastel",
        label: "Pastel mơ",
        css: "saturate(0.85) brightness(1.12) contrast(0.92)"
    },
    {
        id: "dewy",
        label: "Dewy Glow",
        css: "brightness(1.08) saturate(1.05) contrast(0.95)",
        bloom: 0.25
    },
    {
        id: "noir",
        label: "Đen trắng",
        css: "grayscale(1) contrast(1.25)",
        grain: 0.1,
        vignette: 0.2
    },
    {
        id: "cinematic",
        label: "Cinematic",
        css: "contrast(1.2) saturate(1.1) hue-rotate(-8deg) brightness(0.97)",
        vignette: 0.28
    },
    {
        id: "sepia",
        label: "Sepia cổ",
        css: "sepia(0.7) contrast(1.1) brightness(1.02)",
        grain: 0.07,
        vignette: 0.2
    },
    {
        id: "vivid",
        label: "Rực rỡ",
        css: "saturate(1.5) contrast(1.15) brightness(1.02)"
    }
];

export const DEFAULT_FILTER_ID = "none";

export const getFilter = id =>
    FILTERS.find(f => f.id === id) || FILTERS[0];

// Safari chỉ hỗ trợ ctx.filter từ bản 16.4. Nếu thiếu, ta ẩn thanh chọn hiệu ứng
// đi thay vì để người dùng chọn rồi không thấy gì thay đổi trên ảnh tải về.
export const supportsCanvasFilter = (() => {
    if (typeof document === "undefined") return false;
    const ctx = document.createElement("canvas").getContext("2d");
    return !!ctx && "filter" in ctx;
})();
